import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    gap: 10,
    css: css`
        margin-top: 20px;
    `,
};
creditCardDetailsEntryStyles.expirationMonthGridItem = {
    width: [12, 6, 6, 6, 6],
};
creditCardDetailsEntryStyles.expirationYearGridItem = {
    width: [12, 6, 6, 6, 6],
};

creditCardDetailsEntryStyles.creditCardDetailsHeading = {
    css: css`
        background-color: ${getColor("secondary")};
        padding: 10px 17px;
        margin-bottom: 10px;
        color: ${getColor("info")} !important;
        font-size: 16px;
        font-weight: 500;
        font-family: "MontserratRegular";
        width: 100%;
`,

};